import { createFileRoute } from '@tanstack/react-router'
import { FeatureLanding } from './-components/feature-landing'
import { buildSeo } from './-lib/seo'
import { createSiteTranslate } from './-lib/site-i18n'

export const Route = createFileRoute('/(public)/collection-tracker')({
	ssr: true,
	head: ({ match }) => {
		const { appLanguage } = match.context
		const t = createSiteTranslate(appLanguage)
		return buildSeo({
			appLanguage,
			path: '/collection-tracker',
			title: t('site:seo.collection_tracker.title'),
			description: t('site:seo.collection_tracker.description')
		})
	},
	component: CollectionTrackerPage
})

function CollectionTrackerPage() {
	const { appLanguage } = Route.useRouteContext()
	const t = createSiteTranslate(appLanguage)

	return (
		<FeatureLanding
			ctaSubtitle={t('site:landing.download.subtitle')}
			ctaTitle={t('site:collection_tracker.cta.title')}
			eyebrow={t('site:collection_tracker.hero.eyebrow')}
			features={[
				{
					body: t('site:collection_tracker.f1.body'),
					title: t('site:collection_tracker.f1.title')
				},
				{
					body: t('site:collection_tracker.f2.body'),
					title: t('site:collection_tracker.f2.title')
				},
				{
					body: t('site:collection_tracker.f3.body'),
					title: t('site:collection_tracker.f3.title')
				}
			]}
			lead={t('site:collection_tracker.hero.lead')}
			t={t}
			title={t('site:collection_tracker.hero.title')}
		/>
	)
}
